// components/SearchBox.js

import React from "react";

export default function SearchBox({ value, onChange }) {
  return <input placeholder="Search" value={value} onChange={onChange} />;
}
